import React, {useCallback, useEffect, useState} from "react";
import {
    Box,
    Card,
    CardActionArea, CardActions, CardContent,
    Chip, Dialog, DialogActions, DialogContent,
    Divider, Drawer, IconButton,
    ListItem,
    ListItemAvatar,
    ListItemText, Select, TextField,
    Typography
} from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import {LoadingButton, Skeleton} from "@mui/lab";
import {StorageService} from "../../services/StorageService";
import {useNavigate, useParams} from "react-router-dom";
import Vimeo from '@u-wave/react-vimeo';
import {CourseService} from "../../services/CourseService";
import {useTranslation} from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {UserLibraryService} from "../../services/UserLibraryService";

const Course = () => {

    const {t} = useTranslation();

    const { id } = useParams();
    const navigate = useNavigate();


    const [course, setCourse] = useState(null);
    const [courseCategory, setCourseCategory] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isAddingCourseToLibrary, setIsAddingCourseToLibrary] = useState(false);

    const [isCourseInUserLibrary, setIsCourseInUserLibrary] = useState(false);
    const [isAddToLibraryDialogOpen, setIsAddToLibraryDialogOpen] = useState(false);

    const [videos, setVideos] = useState(null);
    const [accessCode, setAccessCode] = useState('');


    const [selectedVideo, setSelectedVideo] = useState(null);

    const user = StorageService.loadUser();

    useEffect( async () => {
        await getCourse();
    }, []);



    const getCourse = async () => {
        setIsLoading(true);

        const response =  await CourseService.getCourse(id, user?.token);
        // @ts-ignore
        const resJson = await response.json();

        const {data, message} = resJson;
        setIsLoading(false);

        // @ts-ignore
        if (response.ok) {
            if (data) {
                setCourse(data.course);
                setVideos(data.videos);
                setCourseCategory(data.category);
                setIsCourseInUserLibrary(data.isInUserLibrary);

            } else {
                alert(data.message);
            }
        } else {
            alert(message);
        }
    };

    const handleFieldChange = useCallback(
        (callback, e) => {
            const value = e.target.value;
            callback(value);

        },
        [setAccessCode],
    );

    const addToLibrary = async () => {

        if (!accessCode) {
            alert(t("app.enterAccessCodeLabel"));
            return;
        }
        setIsAddToLibraryDialogOpen(false);
        setIsAddingCourseToLibrary(true);
        const response =  await UserLibraryService.addToLibrary(
            accessCode,
            course.uid,
            'course',
            user?.token);
        // @ts-ignore
        const resJson = await response.json();

        const {data, message} = resJson;
        setIsAddingCourseToLibrary(false);

        // @ts-ignore
        if (response.ok) {
            if (data) {
                alert(t("app.courseAddedToLibraryLabel"));
                setIsCourseInUserLibrary(true);

            } else {
                alert(data.message);
            }
        } else {
            alert(message);
        }
    }

    return (

        <React.Fragment>

            <Box>

                {isLoading && (
                    <>
                        <Skeleton/>
                        <Skeleton/>
                        <Skeleton/>
                        <Skeleton/>
                        <Skeleton/>
                        <Skeleton/>

                    </>
                )}

                {!isLoading && course && (
                    <>

                        <Button
                            onClick={() => navigate(-1)}
                            size={"small"}
                            startIcon={<ArrowBackIcon />}
                            sx={{marginLeft: -2}}
                        >
                            {t("app.backButtonLabel")}
                        </Button>
                        <ListItem sx={{marginLeft: -3}}>
                            <ListItemText
                                primary={
                                    <Typography variant="h1" mb={.25}>
                                        {course.name}
                                    </Typography>
                                }
                                secondary={
                                    <Typography component={"div"}>
                                        <Typography variant='subtitle2'>
                                            {courseCategory?.name}
                                        </Typography>
                                        <Typography variant='subtitle2'>
                                            {t('app.languageLabel')}: {course.language}
                                        </Typography>
                                        <Typography variant='body1'>
                                            {course.description}
                                        </Typography>

                                        {!isCourseInUserLibrary && (
                                            <Box mt={1}>
                                                <LoadingButton loading={isAddingCourseToLibrary} sx={{marginRight: 1}} size="small" color="primary" variant={'contained'}
                                                               onClick={() => {setIsAddToLibraryDialogOpen(true)}}>
                                                    {t('app.addCourseToLibraryButtonLabel')}
                                                </LoadingButton>
                                            </Box>
                                        )}

                                    </Typography>
                                }
                            />
                        </ListItem>
                    </>

                )}


            </Box>

            <Divider/>

            <Box mt={5}>
                <Typography variant={'h2'}>
                    {t('app.videosLabel')}
                </Typography>

                <Box mt={3}>

                    {!isLoading && videos?.length < 1 && (

                        <Card>
                            <CardContent>
                                <Box sx={{ justifyContent: 'center',  display: 'flex'  }}>
                                    <Typography variant={'h4'}>
                                        {t('app.courseHasNoVideosLabel')}
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    )}

                    {!isLoading && videos?.length > 0 && (
                        <Grid container spacing={3.75} mb={3}>
                        {videos.map( (video, index) =>
                                (
                                    <Grid item xs={12} sm={6} lg={4}>
                                        <Card >
                                            <CardActionArea>
                                                {isCourseInUserLibrary && (
                                                    <Vimeo
                                                        video={video.link}
                                                        autopause
                                                        showByline={false}
                                                        showTitle={false}
                                                        autopip
                                                        pip
                                                        responsive={true}
                                                        controls={true}
                                                        speed={true}
                                                    />
                                                )}

                                                {!isCourseInUserLibrary && (
                                                    <Vimeo
                                                        video={video.link}
                                                        autopause
                                                        showByline={false}
                                                        showTitle={false}
                                                        autopip
                                                        pip
                                                        responsive={true}
                                                        controls={false}
                                                    />
                                                )}

                                                <CardContent sx={{height: 200, marginBottom: 15}}>
                                                    <Typography gutterBottom variant="h5" component="div">
                                                        {video.name}
                                                    </Typography>
                                                    <Typography variant='subtitle2'>
                                                        {t('app.languageLabel')}: {video.language}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {video.description}
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                )
                            )}
                        </Grid>
                    )}
                </Box>
            </Box>

            <Dialog
                open={isAddToLibraryDialogOpen}
                onClose={() => setIsAddToLibraryDialogOpen(false)}
            >
                <DialogTitle>
                    {t('app.enterAccessCodeLabel')}
                </DialogTitle>
                <DialogContent>
                   <Box mb={2} width={500}>
                    <TextField
                        label={t('app.accessCodeLabel')}
                        placeholder={t('app.enterAccessCodeLabel')}
                        fullWidth
                        value={accessCode}
                        onChange={(e) =>
                        {handleFieldChange(setAccessCode, e)}}
                        sx={{ marginBottom: 1, marginTop: 2 }}
                    />
                </Box>
                </DialogContent>
                <DialogActions>
                    <Button color={'error'} variant={'contained'} onClick={() => setIsAddToLibraryDialogOpen(false)}>
                        {t('app.closeButtonLabel')}
                    </Button>
                    <Button color={'primary'} variant={'contained'} onClick={addToLibrary}>
                        {t('app.addCourseToLibraryButtonLabel')}
                    </Button>

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default Course;